/**
 * Store: Product add-on
 * -----------------------------------------------------------------------------
 * Tracks what product handle should be displayed in product add on drawer.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    lineItem: false,
    product: '',
    quantity: 1,
    variant: false,
  }),

  mutations: {

    /**
     * Set line item object to load add-on data from.
     * @param {Boolean|Object} lineItem - Line item.
     */
    SET_LINE_ITEM(state, lineItem = false) {
      state.lineItem = lineItem
    },

    /**
     * Set product object to load add-on data from.
     * @param {String} handle - Main product handle.
     */
    SET_PRODUCT(state, handle) {
      state.product = handle
    },

    /**
     * Set quantity.
     * @param {Number} quantity - Quantity.
     */
    SET_QUANTITY(state, quantity) {
      state.quantity = quantity
    },

    /**
     * Set product variant.
     * @param {String} variant - Main product variant.
     */
    SET_VARIANT(state, variant) {
      state.variant = variant
    },
  },

  actions: {

    /**
     * Open add-on drawer.
     */
    openDrawer({ dispatch }) {
      const data = {
        component: 'product-add-on-drawer',
        ignoreDismissed: true,
        namespace: 'productAddOnDrawer',
      }

      dispatch('overlays/open', data, { root: true })
    },

    /**
     * Set line item object to load add-on data from.
     * - Also used to keep track of line item which needs updating when adding
     *   add-on product to cart.
     * @param {Boolean|Object} lineItem - Line item.
     */
    setLineItem({ commit, dispatch }, lineItem = false) {
      commit('SET_LINE_ITEM', lineItem)

      if (!lineItem) {
        return
      }

      dispatch('openDrawer')
    },

    /**
     * Set product handle.
     * - Used to store product handle which contains product add-on metaobject
     *   details, this handle is queried.
     * - Metaobject contains add-on product that needs querying.
     * @param {String} handle - Main product handle.
     */
    setProduct({ commit, dispatch }, handle = '') {
      commit('SET_PRODUCT', handle)

      if (!handle) {
        return
      }

      dispatch('openDrawer')
    },

    /**
     * Set quantity.
     * @param {Number} quantity - Quantity.
     */
    setQuantity({ commit }, quantity = 1) {
      commit('SET_QUANTITY', quantity)
    },

    /**
     * Set main product variant.
     * - Used to keep track of variant that needs adding with add-on product.
     * @param {Boolean|Object} variant - Main product variant.
     */
    setVariant({ commit }, variant = false) {
      commit('SET_VARIANT', variant)
    },
  },
}
